import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'

import { media } from '../../../styles/utils'
import { container, bgIcon, padding, hoverState, bgImage } from '../../../styles/global'
import { ribbon } from '../../../styles/colors';
import { heading } from '../../../styles/type';

class BlockHeading extends React.Component {

	state = {
	
	}
	
	render() {
		const { heading } = this.props;
        
		return (
            <Heading
                dangerouslySetInnerHTML={{__html: heading}}  
            />
		)
	}
}


const Heading = styled.div`
	width: 440px;
	max-width: 100%;
	text-align: center;
	${heading};

	${media.laptop`
		width: 346px;
	`}
	
	${media.tablet`
		width: 360px;
	`}
	
	${media.phone`
		width: 295px;
	`}
`

BlockHeading.wrapper = css`
	display: flex;
	justify-content: center;
	${padding};
`

export default BlockHeading



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockHeading.js